import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpDownloadService } from '../../services/download/http-download.service'; // Adjust path
import { ToastrService } from 'ngx-toastr';

// NG-ZORRO Imports
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzEmptyModule } from 'ng-zorro-antd/empty'; // <-- Added here
import { TopbarComponent } from '../../layout/topbar/topbar.component';
import { NzHeaderComponent } from 'ng-zorro-antd/layout';

@Component({
    selector: 'app-secure-download',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        NzCardModule,
        NzInputModule,
        NzButtonModule,
        NzFormModule,
        NzTypographyModule,
        NzIconModule,
        NzEmptyModule,
        TopbarComponent,
        NzHeaderComponent // <-- Added here
    ],
    templateUrl: './secure-download.component.html',
    styleUrls: ['./secure-download.component.scss']
})
export class SecureDownloadComponent implements OnInit {
    
    uuid: string | null = null;
    password = '';
    isDownloading = false;
    hasError = false;
    errorMessage = '';

    constructor(
        private route: ActivatedRoute,
        private downloadService: HttpDownloadService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.uuid = this.route.snapshot.paramMap.get('uuid');
        
        if (!this.uuid) {
            this.hasError = true;
            this.errorMessage = 'Invalid download link. Missing secure token.';
        }
    }

    downloadFile() {
        if (!this.password || this.password.length < 10) {
            this.toastr.warning('Please enter the password provided in your email.');
            return;
        }

        if (!this.uuid) return;

        this.isDownloading = true;
        this.hasError = false;

        this.downloadService.downloadSecureFile(this.uuid, this.password).subscribe({
            next: (response) => {
                this.isDownloading = false;
                
                let filename = 'secure-sdk-download.zip'; 
                const disposition = response.headers.get('Content-Disposition');
                if (disposition && disposition.indexOf('filename=') !== -1) {
                    const matches = /filename="([^"]+)"/.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1];
                    }
                }

                if (response.body) {
                    const blob = new Blob([response.body], { type: response.body.type });
                    const downloadUrl = window.URL.createObjectURL(blob);
                    
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(downloadUrl);
                    
                    this.toastr.success('Download started successfully!');
                    this.password = ''; 
                }
            },
            error: (err) => {
                this.isDownloading = false;
                this.hasError = true;
                
                if (err.status === 401) {
                    this.errorMessage = 'Incorrect password. Please try again.';
                    this.toastr.error('Incorrect password');
                } else if (err.status === 410) {
                    this.errorMessage = 'This download link has expired.';
                } else {
                    this.errorMessage = 'An error occurred while trying to download the file. Please contact support.';
                }
            }
        });
    }
}